import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-91ffe03e"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "device-detail"
};
const _hoisted_2 = {
  class: "banner"
};
const _hoisted_3 = {
  class: "common"
};
const _hoisted_4 = {
  class: "title"
};
const _hoisted_5 = {
  class: "content"
};
const _hoisted_6 = {
  class: "common",
  style: {
    display: 'flex'
  }
};
const _hoisted_7 = {
  class: "desc"
};
const _hoisted_8 = {
  class: "title"
};
const _hoisted_9 = ["innerHTML"];
const _hoisted_10 = {
  class: "section3 section center"
};
const _hoisted_11 = {
  class: "common"
};
const _hoisted_12 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h3", {
  class: "title"
}, [/*#__PURE__*/_createElementVNode("span", {
  class: "text"
}, "产品特点"), /*#__PURE__*/_createElementVNode("b", {
  class: "dec"
})], -1));
const _hoisted_13 = {
  class: "table-feature"
};
const _hoisted_14 = {
  key: 0,
  class: "feature-title"
};
const _hoisted_15 = {
  key: 0,
  class: "section4 section"
};
const _hoisted_16 = {
  class: "common"
};
const _hoisted_17 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h3", {
  class: "title"
}, [/*#__PURE__*/_createElementVNode("span", {
  class: "text"
}, "技术参数"), /*#__PURE__*/_createElementVNode("b", {
  class: "dec"
})], -1));
import { ref, onMounted } from 'vue';
import product from './data/product';
import { useRoute } from 'vue-router';
export default {
  __name: 'device-detail',
  setup(__props) {
    const route = useRoute();
    const data = product[route.params.id];
    const tableEl = ref();
    const getFeatureStyle = () => {
      const arr = data.section3.feature;
      if (arr && arr.length > 1 || arr[0].length > 2) {
        return {
          justifyContent: 'center'
          // alignItems: 'center',
        };
      }

      return {
        justifyContent: 'flex-start'
        // alignItems: 'flex-start',
      };
    };

    onMounted(() => {
      setTimeout(() => {
        const h = tableEl.value.getBoundingClientRect().height;

        // tableEl.value.style.marginTop = h / 6 + 'px'
        // tableEl.value.style.marginTop = h / 36 + 'px'
        // // tableEl.value.style.marginBottom = h / 6 + 'px'
      });
    });

    return (_ctx, _cache) => {
      const _component_el_table_column = _resolveComponent("el-table-column");
      const _component_el_table = _resolveComponent("el-table");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("h3", _hoisted_4, _toDisplayString(_unref(data).section1.title), 1)])]), _createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_createElementVNode("span", {
        class: "img bak",
        style: _normalizeStyle(`background-image:url(${_unref(data).section2.img})`)
      }, null, 4), _createElementVNode("div", _hoisted_7, [_createElementVNode("h3", _hoisted_8, _toDisplayString(_unref(data).section2.title), 1), _createElementVNode("p", {
        innerHTML: _unref(data).section2.desc,
        class: "text"
      }, null, 8, _hoisted_9)])])]), _createElementVNode("div", _hoisted_10, [_createElementVNode("div", _hoisted_11, [_hoisted_12, _createElementVNode("div", {
        class: "inner_wrap",
        style: _normalizeStyle(getFeatureStyle())
      }, [_createElementVNode("div", _hoisted_13, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(data).section3.feature, (row, index) => {
        return _openBlock(), _createElementBlock("div", {
          key: index,
          class: "feature"
        }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row, (item, index) => {
          return _openBlock(), _createElementBlock("div", {
            key: index,
            class: "row"
          }, [item.title ? (_openBlock(), _createElementBlock("h3", _hoisted_14, _toDisplayString(item.title), 1)) : _createCommentVNode("", true), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.arr, (text, index) => {
            return _openBlock(), _createElementBlock("span", {
              key: index,
              class: "text"
            }, _toDisplayString(text), 1);
          }), 128))]);
        }), 128))]);
      }), 128))])], 4)])]), _unref(data) ? (_openBlock(), _createElementBlock("div", _hoisted_15, [_createElementVNode("div", _hoisted_16, [_hoisted_17, _createElementVNode("div", {
        ref_key: "tableEl",
        ref: tableEl,
        class: "table_wrap"
      }, [_createVNode(_component_el_table, {
        size: "large",
        data: _unref(data).section4.tableData,
        style: {
          "width": "100%"
        },
        "header-cell-class-name": "header-cell",
        "default-expand-all": "",
        "row-key": "name",
        "tree-props": {
          children: 'children',
          hasChildren: 'hasChildren'
        }
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(data).section4.column, (item, index) => {
          return _openBlock(), _createBlock(_component_el_table_column, {
            key: index,
            prop: item.key,
            label: item.name,
            width: item.with
          }, null, 8, ["prop", "label", "width"]);
        }), 128))]),
        _: 1
      }, 8, ["data"])], 512)])])) : _createCommentVNode("", true)]);
    };
  }
};